import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { Card, CardTitle } from "reactstrap";
import NumericFormat from "../../../../components/react-number-format/NumericFormat";
import Loading from "../../../../components/Loading";
import { loadFirstPriceByVariantInvestmentItemIdOrderByInstantDesc } from "../../../../actions";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormLatestPriceStep(props) {
  var variantInvestmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItem");
  });
  var variantInvestmentItemId = variantInvestmentItem.id;
  var price = useSelector(function (state) {
    return state.entities.prices.firstByVariantInvestmentItemIdOrderByInstantDesc[variantInvestmentItemId];
  });
  useEffect(function () {
    props.loadFirstPriceByVariantInvestmentItemIdOrderByInstantDesc(variantInvestmentItemId);
  }, [variantInvestmentItemId]);
  useEffect(function () {
    price && props.change("price", price);
  }, [price]);
  if (!price) return /*#__PURE__*/React.createElement(Card, {
    body: true,
    inverse: true,
    color: "brand-primary",
    className: "m-0 rounded"
  }, /*#__PURE__*/React.createElement(Loading, {
    dataSpinnerColor: "rgba(255, 255, 255, 0.8)"
  }));
  return /*#__PURE__*/React.createElement(Card, {
    body: true,
    inverse: true,
    color: "brand-primary",
    className: "m-0 rounded"
  }, /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h4",
    className: "m-0"
  }, /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    decimalScale: price.currency.unitDecimalScale,
    value: price.value,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, price.currency.unitAbbreviation)));
}
export default connect(undefined, {
  loadFirstPriceByVariantInvestmentItemIdOrderByInstantDesc: loadFirstPriceByVariantInvestmentItemIdOrderByInstantDesc
})(ExchangeWizardFormLatestPriceStep);
ExchangeWizardFormLatestPriceStep.propTypes = {
  loadFirstPriceByVariantInvestmentItemId: PropTypes.func
};